import { render } from "./ModalTabs.vue?vue&type=template&id=64db63d2"
import script from "./ModalTabs.vue?vue&type=script&lang=js"
export * from "./ModalTabs.vue?vue&type=script&lang=js"

import "./ModalTabs.vue?vue&type=style&index=0&id=64db63d2&lang=less"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__